export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    slogan: p => p.accentWhite,
    background: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    slogan: p => p.accentWhite,
    background: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    slogan: p => p.accentWhite,
    background: p => p.tertiaryExtraLight
  }
}
